module.exports = __webpack_public_path__ + "4d22ff24a42a43906ee3b39ef9ee8ccb.pdf";